export default {"src":"/kaimono/_next/static/media/cn_wamazing_h.0a8f6c06.svg","height":116,"width":292};